import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { IconBaseProps } from 'react-icons';

import { useField, FormHandles } from '@unform/core';
import { Container, Field } from './styles';
import { Error } from '../styles';
import { FaChevronDown, FaChevronUp, FaCopy, FaEdit, FaPaste, FaPlus, FaTrash } from 'react-icons/fa';
import { uuid } from 'uuidv4';
import { Form } from '@unform/web';
import Input from '../Input';
import SelectSimple from '../SelectSimple';
import RichText from '../RichText';
import { useModal } from '../../../../../../hooks/Modal';
import JsonList from '../JsonListMultiple';
import ArrayIncluder from '../ArrayInputIncluder';
import MaskedCurrencyInput2 from '../MaskedCurrencyInput2';
import DatePicker from '../DatePicker';
import { useToast } from 'src/hooks/Toast';
import { FiCopy } from 'react-icons/fi';
interface IListInput {
  label: string;
  name: string;
  type?: string;
}

interface IInputProps {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  setCallback?: Function;
  formRef?: React.RefObject<FormHandles>;
  list: Array<IListInput>;
  defaultItem?: Array<Record<string, any>>;
  placeholder: string;
  show?: string | string[];
}

/*
The concept is simple.
Create a form with multiple inputs

*/



const JsonInputList: React.FC<IInputProps> = ({
  name,
  icon: Icon,
  formRef,
  setCallback = () => { },
  placeholder,
  defaultItem,
  list,
  show,
  ...rest
}): JSX.Element => {

  const { addModal, removeModal } = useModal();

  const { fieldName, defaultValue, error, registerField } = useField(name);
  const inputRef = useRef<HTMLInputElement>(null);
const {addToast} = useToast();
  const [value, setValue] = useState(defaultValue || defaultItem || []);


const copyToClipboard = (line) => {

  const lineItem = {
    type: 'line', 
    content : line
  }

const text = JSON.stringify(lineItem);
navigator.clipboard.writeText(text)
  .then(() => {
    addToast({title: "Linha copiada com sucesso!", type:'info'});
  })
   

}


const pasteLine = () => {

navigator.clipboard.readText()
  .then(text => {
    try{
    const content = JSON.parse(text)

    if(content?.type === 'line'){
      setValue(state => [...state, content?.content]);
    }

    }
    catch(err){

    }

  })
  .catch(err => {
    console.error("Erro ao colar:", err);
  });


}



  useEffect(() => {


    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: undefined,
      setValue: (ref: any, value: any) => {
        setValue(value);
      },
      getValue: (ref: any) => {
        return value;
      },
    });
  }, [fieldName, registerField, value]);


  const goUp = index => {
    const indexup = index - 1;

    if (value[indexup]) {
      const newCurrent = [...value];

      newCurrent[index] = value[indexup];
      newCurrent[indexup] = value[index];

      setValue([...newCurrent]);

    }
  };

  const goDown = index => {
    const indexup = index + 1;

    if (value[indexup]) {
      const newCurrent = [...value];

      newCurrent[index] = value[indexup];
      newCurrent[indexup] = value[index];

      setValue([...newCurrent]);
    }
  };

  const defaultValueList = {
    input: '',
    select: '',
    textList: '',
    jsonList: [],
    arrayIncluder: []
  }

  const addRow = () => {
    const newValue = [...value];



    const newLine = Object.keys(list).reduce((prev, key) => {
      prev[list[key].name] = defaultValueList[list?.[key]?.type || 'input'];
      return prev;
    }, {});

    newValue.push(newLine);

    setValue([...newValue]);
  };

  const removeItem = (index) => {

    const item = [...value];
    item.splice(index, 1);

    setValue([...item]);

  }

  const duplicateItem = (index) => {
    const newValue = [...value];
    const newItem = { ...value[index] };


    newValue.push(newItem);

    setValue([...newValue]);

  }

  const printLines = useCallback(() => {

    const items: Array<JSX.Element> = [];
    {
      value.map((v, index) => {

        let display = `Adicione sua pergunta`;

        if (typeof show === 'object') {
          show.map((s, index) => {
            display = index === 0 ? v?.[s] : `${display} - ${v?.[s]}`;
          })

        }
        else if (typeof show === 'string') {
          display = v[show] || 'Adicione sua pergunta';
        }

        const key = uuid();
        items.push(<div key={key} className='display'>
          <p>{display}</p>
          <div className='listModules'>
            <div><FiCopy title="Copiar linha" onClick={() => copyToClipboard(value[index])} size={15} style={{ cursor: 'pointer' }} /></div>
            <div><FaCopy title='Duplicar' onClick={() => duplicateItem(index)} size={15} style={{ cursor: 'pointer' }} /></div>

            <div><FaEdit onClick={() => openInputs(index)} size={15} style={{ cursor: 'pointer' }} /></div>

            <div><FaChevronUp onClick={() => goUp(index)} style={{ cursor: 'pointer' }} /></div>
            <div><FaChevronDown onClick={() => goDown(index)} style={{ cursor: 'pointer' }} /></div>
            <div><FaTrash onClick={() => removeItem(index)} style={{ cursor: 'pointer' }} /></div>
          </div>
        </div>)

      })

      return items;

    }
  }, [value]);


  const validTypes = (listInput,content = '') => {

    const valid = {
      input: (item) => <Input name={item.name} defaultValue={item?.default} placeholder={item.label} />,
      date: (item) => <DatePicker name={item.name} placeholder={item.label} />,
      currency: (item) => <MaskedCurrencyInput2 name={item.name} defaultValue={item?.default} placeholder={item.label} />,
      select: (item) => <SelectSimple name={item.name} label={item.label} options={item.options} />,
      richText: (item) => <RichText defaultV={content || ''} name={item.name} placeholder={item.label} />,
      jsonInputList: (item) => <JsonInputList show={item?.show || 'title'} list={item.list} name={item.name} placeholder={item.label} />,
      jsonList: (item) => <JsonList list={item.list} name={item.name} placeholder={item.label} />,
      arrayIncluder: (item) => <ArrayIncluder name={item.name} placeholder={item.label} />
    }

    return valid[listInput.type] ? valid[listInput.type](listInput) : <></>;

  }

  const openInputs = (index) => {

    const updateItem = (data) => {

      const valuesItems = [...value];
      valuesItems[index] = { ...data };

      setValue([...valuesItems]);
      removeModal(`updateForm-${name}`)

    }
 


    addModal({
      title: 'Atualizar', theme: "whiteModal", key: `updateForm-${name}`, content: <Form ref={formRef} onSubmit={updateItem} initialData={{ ...value[index] }}>

        {list.map((item => {
          return validTypes(item, value[index]?.[item?.name] || '');
        }))}

        <aside className='displayCenter'>
          <button className='defaultButton' style={{ width: '200px', margin: '10px auto' }}>Atualizar</button>
        </aside>

      </Form>
    }
    )

  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '20px 10px', border: '2px solid #eee' }}>
      <h2 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>{placeholder}
          <div className='listModules row gap-xs'>
      <div  > <FaPaste title="Colar linha" onClick={() => pasteLine()} size={20} style={{ margin: '0px 3px', cursor: 'pointer' }} /></div>
        <div  > <FaPlus onClick={() => addRow()} size={20} style={{ margin: '0px 3px', cursor: 'pointer' }} /></div>
        </div>
      </h2>

      <Container>{printLines()}</Container>
    </div>
  );
};

export default JsonInputList;
